import { z } from 'zod';

export const reportExportFormatSchema = z.enum(['pdf', 'csv']);
export type ReportExportFormat = z.infer<typeof reportExportFormatSchema>;

export const reportFilterSchema = z
  .object({
    companyId: z.string().min(1).optional(),
    month: z
      .string()
      .regex(/^\d{4}-(0[1-9]|1[0-2])$/, 'month must be YYYY-MM')
      .optional(),
    format: reportExportFormatSchema.optional(),
    billable: z.boolean().optional(),
    limit: z
      .number()
      .int('Limit must be a whole number')
      .min(1, 'Limit must be at least 1')
      .max(200, 'Limit must be 200 or fewer')
      .default(50),
    cursor: z.string().min(1).optional(),
  })
  .strict();
export type ReportFilterInput = z.infer<typeof reportFilterSchema>;
